import React, { useId } from 'react';

/**
 * StockXignal brand mark — a clean ascending bar chart on the brand gradient badge,
 * with a single highlighted "signal" marker on the tallest bar. Replaces the earlier
 * animated trend-line mark (a jittery redrawing zigzag with a pulsing dot chasing it)
 * with something calmer and more polished — a static glyph that reads clearly at
 * favicon size and doesn't flicker/loop in a page header.
 */
export default function Logo({ size = 28, className = '' }) {
  const rawId = useId().replace(/[^a-zA-Z0-9]/g, '');
  const gradId = `sxg-${rawId}`;
  const markerGradId = `sxm-${rawId}`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <defs>
        <linearGradient id={gradId} x1="0" y1="0" x2="40" y2="40" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#22d3ee" />
          <stop offset="55%" stopColor="#6366f1" />
          <stop offset="100%" stopColor="#8b5cf6" />
        </linearGradient>
        <radialGradient id={markerGradId}>
          <stop offset="0%" stopColor="#22d3ee" />
          <stop offset="100%" stopColor="#0891b2" />
        </radialGradient>
      </defs>

      <rect width="40" height="40" rx="11" fill={`url(#${gradId})`} />

      {/* Four ascending bars — a calm, static "signals trending up" read, brightest
          toward the newest (rightmost) bar. */}
      <rect x="7.5" y="21" width="5" height="10" rx="1.6" fill="white" fillOpacity="0.5" />
      <rect x="15" y="16.5" width="5" height="14.5" rx="1.6" fill="white" fillOpacity="0.68" />
      <rect x="22.5" y="11" width="5" height="20" rx="1.6" fill="white" fillOpacity="0.85" />
      <rect x="30" y="6" width="5" height="25" rx="1.6" fill="white" />

      {/* Signal marker on the newest bar — the one accent, not an animated one */}
      <circle cx="32.5" cy="6" r="3.4" fill={`url(#${markerGradId})`} stroke="white" strokeWidth="1.4" />
    </svg>
  );
}
